import './chartjs-chart-financial.min.js'
import React from 'react'
import ChartComponent from 'react-chartjs-2'
import PropTypes from 'prop-types'

const propTypes = {
  /** Use the naming standards. */
  id: PropTypes.string.isRequired,
  /** Data for the list see sample.js for the sample data */
  data: PropTypes.object
}

const defaultProps = {
  data: {}
}

/**
 * ## CandlestickChart provides a way of showing data values represented as vertical bars.
 *
 * `CandlestickChart` is based on https://www.chartjs.org/chartjs-chart-financial/.
 *
 * A candlestick is a type of price chart used that displays the high, low, open, and closing prices of a security for a specific period.
 *
 */

const CandlestickChart = props => {
  const { data, type, defaultColor, ...rest } = props

  return (
    <ChartComponent
      data={data}
      data-cid='CandlestickChart-root'
      {...rest}
      type='candlestick'
    />
  )
}
CandlestickChart.propTypes = propTypes
CandlestickChart.defaultProps = defaultProps

export default CandlestickChart
